import { ILanguageToggleData } from './language-toggle.data';
import { ILanguageToggleProps } from './language-toggle.props.autogenerated';

export interface ILanguageToggleViewProps extends ILanguageToggleProps<ILanguageToggleData> {}

/**
 *
 * LanguageToggle component
 * @extends {React.PureComponent<ILanguageToggleProps<ILanguageToggleData>>}
 */
const LanguageToggle = (props: ILanguageToggleProps<ILanguageToggleData>) => {
    return props.renderView(props);
};

export default LanguageToggle;
